import SiteSelect from "rivals/components/shared/Subscription/SiteSelect";
import styles from "./SiteSelection.module.scss";
import strings from "./strings";
import { Props } from "./types";
import Step from "../Step";

const { chooseSite, selectSite, selectedSite } = strings;

function SiteSelectionStep({
  handleSelectedSite,
  onClear,
  stepNumber,
  terms
}: Props): JSX.Element {
  return (
    <Step
      className={styles.siteSelectionContainer}
      stepNumber={stepNumber}
      title={chooseSite}
    >
      <>
        <div className={styles.label}>{selectedSite}</div>
        <SiteSelect
          className={styles.siteSelect}
          onChange={handleSelectedSite}
          onClear={onClear}
          placeholder={selectSite}
        />
        {terms}
      </>
    </Step>
  );
}

export default SiteSelectionStep;
